export default {
  pt: {
    // Tutorial não possui textos visíveis para traduzir
  },

  en: {
    // Tutorial doesn't have visible text to translate
  },
}; 